import { TFunction } from "i18next";
import * as yup from "yup";
import { InferType } from "yup";
import { GroupLabelStatusEnum } from "@/domain/grouplabel.interface";

const validationSchema = (t: TFunction) => {
  return yup.object().shape({
    name: yup
      .string()
      .required(t("validations.required"))
      .min(2, t("validations.min_length", { count: 2 }))
      .max(100, t("validations.max_length", { count: 100 })),
    description: yup
      .string()
      .required(t("validations.required"))
      .max(500, t("validations.max_length", { count: 500 })),
    status: yup
      .string()
      .required(t("validations.required"))
      .oneOf(
        Object.values(GroupLabelStatusEnum),
        t("validations.invalid_format"),
      ),
  });
};

export type GroupLabelFormData = InferType<ReturnType<typeof validationSchema>>;

export default validationSchema;
